import React from 'react';
import { FooterPDF } from 'src/assets/Images';
import { Footer, FooterLogo } from './styles';
export var PDFFooter = function () { return (React.createElement(Footer, { fixed: true },
    React.createElement(FooterLogo, { src: FooterPDF }))); };
export default PDFFooter;
